var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { flex: "dir:top" } }, [
    _c("div", { staticStyle: { height: "50px" }, attrs: { "flex-box": "0" } }, [
      _c("div", [
        _c("img", {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.collapse,
              expression: "collapse",
            },
          ],
          staticStyle: {
            width: "43px",
            height: "38px",
            "margin-left": "10px",
            "margin-top": "5px",
          },
          attrs: {
            src:
              _vm.$baseUrl +
              "images/theme/" +
              _vm.activeName +
              "/logo/index-logo-collapsed.png",
          },
          on: { click: _vm.backToHome },
        }),
        _c("img", {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.collapse,
              expression: "!collapse",
            },
          ],
          staticStyle: { width: "150px", "margin-left": "10px" },
          attrs: {
            src:
              _vm.$baseUrl +
              "images/theme/" +
              _vm.activeName +
              "/logo/index-logo.png",
          },
          on: { click: _vm.backToHome },
        }),
      ]),
    ]),
    _c(
      "div",
      { attrs: { "flex-box": "1", flex: "dir:top" } },
      [
        _vm.sidebar && _vm.sidebar.length > 0
          ? _c(
              "el-menu",
              {
                staticClass: "u8-sidebar-menu-group",
                class: { "u8-sidebar-menu-group__collapsed": _vm.collapse },
                attrs: {
                  "unique-opened": "",
                  "default-active": _vm.currActive,
                  collapse: _vm.collapse,
                },
                on: { select: _vm.handleMenuSelect },
              },
              [
                _vm._l(_vm.sidebar, function (menuItem, index) {
                  return [
                    menuItem.children && menuItem.children.length > 0
                      ? _c(
                          "el-submenu",
                          {
                            key: index,
                            staticClass: "u8-sidebar-menu-sub",
                            attrs: { index: menuItem.path },
                          },
                          [
                            _c("template", { slot: "title" }, [
                              _c("i", {
                                staticClass: "iconfont",
                                class: menuItem.icon,
                              }),
                              _c("span", [_vm._v(_vm._s(menuItem.name))]),
                            ]),
                            _vm._l(
                              menuItem.children,
                              function (menuChild, index) {
                                return _c(
                                  "el-menu-item",
                                  {
                                    key: index,
                                    staticClass: "u8-sidebar-menu-item-sub",
                                    attrs: { index: menuChild.path },
                                  },
                                  [_vm._v(" " + _vm._s(menuChild.name) + " ")]
                                )
                              }
                            ),
                          ],
                          2
                        )
                      : _c(
                          "el-menu-item",
                          {
                            key: index,
                            staticClass: "u8-sidebar-menu-item",
                            attrs: { index: menuItem.path },
                          },
                          [
                            _c("i", {
                              staticClass: "iconfont",
                              class: menuItem.icon,
                            }),
                            _c(
                              "span",
                              { attrs: { slot: "title" }, slot: "title" },
                              [_vm._v(_vm._s(menuItem.name))]
                            ),
                          ]
                        ),
                  ]
                }),
              ],
              2
            )
          : _vm._e(),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }